import React, { useState } from "react";
import emailjs from "@emailjs/browser";
import { Row, Col, Form } from "react-bootstrap";
import { Button, ComponentContainer, ContactBg } from "../styled.js";
import { useLanguage } from "../i18n/LanguageContext";

const Contact = () => {
  const { t } = useLanguage();
  const [error, setError] = useState();

  const intialState = {
    name: "",
    email: "",
    message: "",
  };
  const [state, setState] = useState(intialState);

  const handleInputChange = (event) => {
    setState({
      ...state,
      [event.target.name]: event.target.value,
    });
  };

  const sendMessage = async (event) => {
    event.preventDefault();
    setError("");
    const { name, email, message } = state;
    const templateParams = {
      name: name,
      email: email,
      message: t.contact.emailBodyPrefix + message,
    };
    emailjs
      .send(
        "gmail",
        "tonitest",
        templateParams,
        process.env.REACT_APP_EMAILJS_USER
      )
      .then(
        function (response) {
          setError(t.contact.messageSent);
          setState(intialState);
        },
        function (error) {
          setError(t.contact.messageError);
        }
      );
  };
  return (
    <div id="contact">
      <ContactBg>
        <ComponentContainer>
          <br />
          <br />
          <h2>{t.contact.heading}</h2>
          <table>
            <tbody>
              <tr>
                <td>{t.contact.gigSales}</td>
              </tr>
              <tr>
                <td>
                  <a href="https://www.facebook.com/headagencyfinland/">
                    Head Agency, <a href="mailto:keikat.head@gmail.com">
                    keikat.head@gmail.com
                  </a>
                  </a>
                </td>
              </tr>
              <br />
              <tr>
                <td>{t.contact.band}</td>
              </tr>
              <tr>
                <td>
                  <a href="mailto:alinenofficial@gmail.com">
                    alinenofficial@gmail.com
                  </a>
                </td>
              </tr>
            </tbody>
          </table>
          <br />
          <h4>{t.contact.sendMessage}</h4>
          <Form className="search-form" onSubmit={sendMessage}>
            {error && <p className="errorMsg">{error}</p>}
            <Row>
              <Col>
                <Form.Group controlId="name">
                  {/* <FormStyle> */}
                  <Form.Control
                    type="text"
                    name="name"
                    value={state.name || ""}
                    placeholder={t.contact.namePlaceholder}
                    onChange={handleInputChange}
                  />
                  {/* </FormStyle> */}
                </Form.Group>
              </Col>
            </Row>
            <Row>
              <Col>
                <Form.Group controlId="name">
                  <Form.Control
                    type="text"
                    name="email"
                    value={state.email || ""}
                    placeholder={t.contact.emailPlaceholder}
                    onChange={handleInputChange}
                  />
                </Form.Group>
              </Col>
            </Row>
            <Row>
              <Col>
                <Form.Group controlId="name">
                  <Form.Control
                    as="textarea"
                    rows={10}
                    name="message"
                    value={state.message || ""}
                    placeholder={t.contact.messagePlaceholder}
                    onChange={handleInputChange}
                  />
                </Form.Group>
              </Col>
            </Row>
            <Button variant="info" type="submit">
              {t.contact.send}
            </Button>
            <br />
            <br />
            <br />
            <br />
          </Form>
        </ComponentContainer>
      </ContactBg>
    </div>
  );
};

export default Contact;
